
<template>
  <div>
    <div v-show="loading">
      <naj-loader></naj-loader>
    </div>

    <v-row>
      <v-col cols="12">
        <naj-tree-node
          :root-item="rootItem"
          :items-list="itemsList"
          :node-result-value="nodeResultValue"
          :preselected-answers="preselectedAnswers"
          :disabled="disabled"
          @all-selections="handleAnswer"
          @final-result="handleFinalRes"
        >
        </naj-tree-node>
      </v-col>
    </v-row>
    <v-row v-if="errorMessage">
      <v-col cols="12">
        <ul>
          <li class="error--text">
            {{ errorMessage }}
          </li>
        </ul>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NajTreeNode from './naj-tree-node.vue';
export default {
  name: 'NajTree',
  components: { NajTreeNode },
  props:
  {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    nodeResultValue: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    rootItem: {
      type: Object,
      default: null,
    },
    itemsList: {
      type: Array,
      default: () => ([]),
    },
    preselectedAnswers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { res: null };
  },
  methods: {
    handleAnswer(answer) {
      this.$emit('all-selections', answer);
    },
    handleFinalRes(res) {
      this.$emit('final-result', res);
    },

  },
};
</script>

<style scoped>
.loader {
  position: fixed;
  top: 20%;
  left: 0;
  right: 0;
  bottom: 0;
  background: #eeeeee99;
  z-index: 1;
}
</style>
